import React from 'react';
import { useSelector } from 'react-redux';

import { ReactComponent as Illustration } from '../../assets/3.svg';
import styles from './NetWorth.module.css';
import { Asset, Debt } from '../../types/accounts';
import { AppState } from '../../store';
import Button from '../../components/UI/Button';
import BurnRate from './BurnRate';
import { convertValue } from '../../utils/convertValue';
import { ExchangeRates } from '../../types/exchangeRates';

interface NetWorthProps {
  onAddAccount?: Function;
  onEditBurnRate?: Function;
}

const calculateNetWorth = (
  assets: Asset[],
  debts: Debt[],
  rates: ExchangeRates | null
) => {
  const totalAssets = assets.reduce(
    (prev: number, current: Asset) =>
      prev + (rates ? convertValue(current.value, rates[current.currency]) : 0),
    0
  );
  const totalDebts = debts.reduce(
    (prev: number, current: Debt) =>
      prev + (rates ? convertValue(current.value, rates[current.currency]) : 0),
    0
  );

  const netWorth = totalAssets - totalDebts;
  return netWorth;
};

const NetWorth: React.FC<NetWorthProps> = ({
  onAddAccount,
  onEditBurnRate,
}) => {
  const { assets, debts, burnRate, rates } = useSelector((state: AppState) => ({
    assets: state.assets,
    debts: state.debts,
    burnRate: state.burnRate,
    rates: state.exchangeRates,
  }));

  const netWorth = calculateNetWorth(assets, debts, rates);

  return (
    <div className={styles.container}>
      <Illustration />
      <div className={styles.info}>
        <h2>
          Your current net worth:{' '}
          <span className={styles.emphasize}>${netWorth.toFixed(2)}</span>
        </h2>
        <BurnRate netWorth={netWorth} />
        {/* <p>
          We pulled up the latest exchange rates to make sure the end result is
          as accurate as possible <br />
          Do your best to add new assets and debts at least once a month <br />
          Keep checking this app as often as you can to see if you’re already
          broke <br />
        </p> */}
        <p>
          <span className={styles.emphasize}>Disclaimer:</span> This app
          references an opinion and is for information purposes only. It is not
          intended to be investment advice.
        </p>
      </div>
      <div className={styles.buttonsContainer}>
        <Button
          value={`${burnRate ? 'Edit' : 'Add'} burn rate`}
          invert
          className={styles.button}
          onClick={() => onEditBurnRate && onEditBurnRate()}
        />
        <Button
          value="Add account"
          invert
          className={styles.button}
          onClick={() => onAddAccount && onAddAccount()}
        />
      </div>
    </div>
  );
};

export default NetWorth;
